import axios from "axios";

const apiClient = axios.create({
  // baseURL: 'https://api.fantasylineups.com/',
  baseURL: "https://api.fantasylineups.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  // adapter: cache.adapter,
});

export default {
  getAllTeams() {
    return apiClient.post("mlb/getAllteams");
  },

  getDepthChart(params) {
    return apiClient.post("mlb/getdepthchart", params);
  },

  getUpcomingGames(params) {
    return apiClient.post("mlb/getupcomingmatch", params);
  },

  getInjuries(params) {
    return apiClient.post("mlb/getinjuries", params);
  },

  async getAllSlate(token) {
    return await apiClient.get(`mlb/getAllSlat/${token}`);
  },

  getPlayersDetails(params) {
    return apiClient.post("mlb/getPlayers", params);
  },

  getTeamBuild(params) {
    return apiClient.post("mlb/createbuild/", params);
  },

  getPlayerSwap(params) {
    return apiClient.post("mlb/getswapplayers", params);
  },

  savedLineup(buildTeam) {
    return apiClient.post("user/saveLineup", buildTeam);
  },

  getTeamStack(params) {
    return apiClient.post("mlb/getTeamsBySlatID", params);
  },

  playerPerTeam(TeamsDetails) {
    return apiClient.post("user/playerPerTeam", TeamsDetails);
  },

  mlbPlayerPerTeam(TeamsDetails) {
    return apiClient.post("user/mlbplayerPerTeam", TeamsDetails);
  },

  resetPlayers(params) {
    return apiClient.post("user/resetSlat", params);
  },

  unlockPlayer(params) {
    return apiClient.post("user/unlockPlayer", params);
  },

  setTopPlays(params) {
    return apiClient.post("user/setTopPlays", params);
  },

  // ?api for top plays feature...
  getTopPlays(params) {
    return apiClient.post("user/getTopplays", params);
  },

  getPremiumFilters(params) {
    return apiClient.post("user/getSlatClients", params);
  },

  // ? api for top plays table/page...
  getTopPlayers(params) {
    return apiClient.post("mlb/getTopPlayers", params);
  },

  getPlayerTrend(params) {
    return apiClient.post("user/getPlayerTrends", params);
  },

  teamDetails(params) {
    return apiClient.post("mlb/teamProfile", params);
  },

  //* player details...
  getFullStat(params) {
    return apiClient.post("mlb/playerDetails", params);
  },

  // getPlayerFullStats(params) {
  //   return apiClient.post('user/getFullStats', params);
  // },

  getPlayerScoring(params) {
    return apiClient.post("user/getPlayerScore", params);
  },
  //* player details...

  updateLineup(params) {
    return apiClient.post("user/updateLineup", params);
  },

  getMlbProps() {
    return apiClient.get("mlb/mlb_props");
  },

  getAvgDraftPos() {
    return apiClient.get("mlb/get_all_adp");
  },

  getDailyLineups() {
    return apiClient.get("mlb/starting_lineups");
  },

  getMlbNews() {
    return apiClient.get("mlb/mlb_news");
  },
};
